import React from 'react'
import Cuposenvios from './Cuposenvios';
import { Container } from 'semantic-ui-react';
import { Grid } from 'semantic-ui-react';
import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography,
  CircularProgress
} from '@mui/material';
const Cuentaempresa = (props) => {
//  console.log(props.userBalance)

  if(props.services){
    var servicesActivos = props.services.filter(item => item.isActive === true)
  }
  
  return (
    <Container className='dashcontent'>
    <Grid celled='internally'  id='mi-cuentaContent'>
    <div><h2> Estado de cuenta</h2></div>
    <Grid.Row> 
    <Grid.Column computer={4} mobile={16} tablet={16}   className='componenbodyservicios'>
     <Card  className='componenbodyservicioscard'>
      <CardContent>
              <h3>Empresa</h3>
              {
               props.dataCompany?(<>
                <Box
                  sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Avatar
                    src={props.dataCompany.avatar}
                    sx={{
                      height: 64,
                      mb: 2,
                      width: 64
                    }}
                  />
                  <Typography
                    color="textPrimary"
                    gutterBottom
                    
                  >
                    {props.dataCompany.companyName}
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="body2"
                  >
                    {`${props.dataCompany.companyRegion} ${props.dataCompany.companyCity}`}
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="body2"
                  >
                    {props.dataCompany.companyRut}
                  </Typography>
                </Box>
                </>):(<>
                {
                  props.errorDatosdeCliente?(<>Registra tu empresa para realizar envíos</>):(<>
                  {
                    props.loadingDatosdeCliente?(<><CircularProgress /></>):(<>
                    2
                    </>)
                  }
                  
                  </>)
                }
                
                
                </>)
              }
              </CardContent>
              <Divider />
             
              <CardActions>
                {/* <Button
                  color="primary"
                  fullWidth
                  variant="text"
                  
                >
                  Actualizar foto
                </Button> */}
              </CardActions>
             
              </Card> 

    </Grid.Column>
    <Grid.Column computer={5} mobile={16} tablet={16}   className='componenbodyservicios'>
      {
        props.userBalance?( <Cuposenvios shippingQuotas={props.userBalance.shippingQuotas} balance={props.userBalance.balance}></Cuposenvios>):(<></>)
      }
   

    </Grid.Column>
    <Grid.Column computer={6} mobile={16} tablet={16}   className='componenbodyservicios'>
    <Card   >
      <CardContent className='componenbodyservicioscard'>
              <h3>Servicios disponibles para envios:</h3>
              {
               props.services?(<>
                <Box
                  
                  sx={{
                    alignItems: 'left',
                    display: 'flex',
                    flexDirection: 'column',
           
                  }}
                >
                  {
                    servicesActivos.map((item ) => (       
                      <span className='badge badge-pill badge-success m-2' key={item.id}>{item.name}</span>
                    ))
                  }
                  
              
              
                </Box>
                </>):(<>
                {
                  props.errorDatosdeCliente?(<>Registra tu empresa para realizar envíos</>):(<>
                  {
                    props.loadingDatosdeCliente?(<><CircularProgress  /></>):(<>
                    2
                    </>)
                  }
                  
                  </>)
                }
                
                
                </>)
              }
              </CardContent>
              <Divider />
             
              <CardActions>
                {/* <Button
                  color="primary"
                  fullWidth
                  variant="text"
                  
                >
                  Actualizar foto
                </Button> */}
              </CardActions>
             
              </Card> 

    </Grid.Column>
    </Grid.Row> 
    </Grid>
    </Container>
  )
}

export default Cuentaempresa